import { footerGroups } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer id="footer" className="w-full bg-accent-50">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500" />
      <div className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-xl text-background-50">
                <i className="ri-flashlight-fill" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料网1</span>
            </div>
            <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-foreground-600">
              把今日头条、最新更新与新料快讯整理成一条能顺着读下去的时间线，蹲进展少翻几页。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["今日更新", "实时滚动", "专题整理"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-accent-200 bg-background-50 px-3 py-1 font-label text-xs text-accent-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8">
            {footerGroups.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-sm font-semibold tracking-wide text-foreground-950">
                  {group.title}
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="cursor-pointer font-body text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-accent-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs text-foreground-500">
            © 2026 黑料网1 · 本站内容为整理与展示，本站为静态演示页面
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5 font-body text-xs text-foreground-500">
              <i className="ri-time-line" />
              最近更新：今日
            </span>
            <a
              href="#top"
              className="cursor-pointer font-body text-xs text-foreground-600 transition-colors hover:text-primary-600"
            >
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}